import { NonEntityUserGuard } from 'Src/ng2/routing/guards/non-entity-user-guard/non-entity-user-guard';

export const exploreRoute = {
  path: 'explore',
  url: '/explore',
  canActivate: [NonEntityUserGuard],
  loadChildren: () => import('../../../../shell/explore/explore.module').then(m => m.ExploreModule),
};
